import { render, staticRenderFns } from "./Fiche.vue?vue&type=template&id=252b5fba&"
import script from "./Fiche.vue?vue&type=script&lang=js&"
export * from "./Fiche.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports